import { defineComponent as _defineComponent } from 'vue'
import { defaultErrorHandler } from '@/admin-shared-modules/utils'
import { MessageBoxService } from '@/admin-shared-modules/utils/message-box.service'
import { computed, ref, watch } from 'vue'
import ResourceForm from '../lib-template/shared/resource-form-shared.vue'
import LibAccount from './form/account/account.component.vue'
import Apps from './form/apps.vue'
import BaseForm from './form/base-form.vue'
import DeviceForm from './form/device-form.vue'
import ReportGrowForm from './form/report-grow-form.vue'
import store from './lib.store'


export default /*#__PURE__*/_defineComponent({
  __name: 'lib-edit.component',
  setup(__props) {

const edit = store.edit
const step = ref(0)

const stepForEdit = computed({
  get: () => `${step.value}`,
  set: val => (step.value = +val)
})

watch(
  () => edit.visible,
  () => (step.value = 0)
)

const baseFormRef = ref<any>(null)
const deviceFormRef = ref<any>(null)
const resourceFromRef = ref<any>(null)

function stepBack() {
  step.value -= 1
}

async function saveAndNext() {
  if (step.value === 0) {
    await baseFormRef.value.getForm().validate()
    await store.edit.onEditSubmit()

    // #TPAD 1000634
    // if ([7, 8, 9].includes(edit.data.lib_type)) {
    //   edit.data.device_type = ['READER']
    //   edit.data.login_type = [2]
    //   edit.data.applications = [2, 4]
    //   edit.data.qk_type = 3
    // }
  }
  if (step.value === 1) {
    await deviceFormRef.value.getForm().validate()
    await store.edit.onEditSubmit()
  }
  if (step.value === 2) {
    await store.edit.onEditSubmit()
  }
  if (step.value === 3) {
    edit.visible = false
    store.list.fetch()
    return
  }
  step.value += 1
}

async function onSubmit() {
  try {
    await baseFormRef.value.getForm().validate()
  } catch (e) {
    console.error(e)
    if (step.value !== 0) {
      step.value = 0
    }
    MessageBoxService.alert({
      type: 'warning',
      title: '提示',
      message: '请检查[机构信息]是否填写完整'
    })
    return
  }
  try {
    await deviceFormRef.value.getForm().validate()
  } catch (e) {
    console.error(e)
    if (step.value !== 1) {
      step.value = 1
    }
    MessageBoxService.alert({
      type: 'warning',
      title: '提示',
      message: '请检查[阅读本设置]是否填写完整'
    })
    return
  }
  try {
    await resourceFromRef.value.getForm().validate()
  } catch (e) {
    console.error(e)
    if (step.value !== 2) {
      step.value = 2
    }
    MessageBoxService.alert({
      type: 'warning',
      title: '提示',
      message: '请检查[资源配置]是否填写完整'
    })
    return
  }

  try {
    await edit.onEditSubmit()
    edit.visible = false
  } catch (e) {
    defaultErrorHandler(e)
  }
}

return { __sfc: true,edit, step, stepForEdit, baseFormRef, deviceFormRef, resourceFromRef, stepBack, saveAndNext, onSubmit, ResourceForm, LibAccount, Apps, BaseForm, DeviceForm, ReportGrowForm }
}

})